import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';
import { screen } from '@/helpers/screen';

export const Story = styled.p`
  max-width: min(736px, 36em);
  margin: 28px auto var(--gap-h2, 56px);
  text-align: center;
  font: 500 clamp(17px, 1.6vw, 20px) / 1.8 ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-primary')});
  text-wrap: pretty;
`;

export const StoryBlock = styled.div`
  max-width: 704px;
  margin: 0 auto 24px;

  h3 {
    margin: 0 0 8px;
    font: 700 18.72px / 1.6 ${getToken('font-family-default')};
    color: rgb(${getToken('color-text-primary')});
  }

  p {
    max-width: 592px;
    margin: 0;
    font: 400 16px/1.6 ${getToken('font-family-default')};
    color: rgb(${getToken('color-text-primary')});
  }
`;

export const Timeline = styled.ol`
  max-width: 704px;
  margin: 8px auto 32px;
  padding: 0;
  list-style: none;
  border-left: 2px solid rgb(${getToken('color-brand')});

  li {
    position: relative;
    display: grid;
    grid-template-columns: 56px minmax(0, 1fr);
    gap: 16px;
    padding: 10px 0 10px 24px;
    font: 500 17px/28px ${getToken('font-family-default')};
    color: rgb(${getToken('color-text-primary')});

    ${screen.md} {
      grid-template-columns: 72px minmax(0, 1fr);
    }
  }

  li::before {
    content: '';
    position: absolute;
    left: -7px;
    top: 18px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgb(${getToken('color-brand')});
  }

  b {
    font: 700 18px/28px ${getToken('font-family-title')};
    color: rgb(${getToken('color-primary-60')});
  }
`;

export const VideosWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  max-width: var(--read, 960px);
  margin: 24px auto 0;

  ${screen.md} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const Video = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  overflow: hidden;
  background: rgb(${getToken('color-background-inverted')});
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

export const VideoLink = styled.a`
  position: absolute;
  inset: 0;
  display: block;
  color: #fff;
  text-decoration: none;
  cursor: pointer;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.55),
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 0.25)
    );
  }
`;

export const VideoTitle = styled.span`
  position: absolute;
  z-index: 2;
  left: 16px;
  right: 16px;
  top: 14px;
  font: 700 16px/1.3 ${getToken('font-family-default')};
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
`;

export const VideoPlay = styled.span`
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  width: 68px;
  height: 48px;
  transform: translate(-50%, -50%);
  background: #f00;
  border-radius: 12px;
  transition: transform 0.15s;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-35%, -50%);
    border-left: 18px solid #fff;
    border-block: 11px solid transparent;
  }

  ${VideoLink}:hover & {
    transform: translate(-50%, -50%) scale(1.08);
  }
`;

export const VideoFrame = styled.iframe`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;
